import { render, staticRenderFns } from "./QPS.vue?vue&type=template&id=ddaf4ad4&"
import script from "./QPS.vue?vue&type=script&lang=js&"
export * from "./QPS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddaf4ad4')) {
      api.createRecord('ddaf4ad4', component.options)
    } else {
      api.reload('ddaf4ad4', component.options)
    }
    module.hot.accept("./QPS.vue?vue&type=template&id=ddaf4ad4&", function () {
      api.rerender('ddaf4ad4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/QPS.vue"
export default component.exports